import React from "react";
import { useAuth } from "../context/AuthContext";
import Navbar from "../components/Navbar";
import PublicNav from "../components/PublicNav";
import { Quote, ExternalLink, Send, Trophy } from "lucide-react";

const ROI_IMG = "https://customer-assets.emergentagent.com/job_market-pulse-pro-48/artifacts/dnxrb94c_ROI%20128.png";
const BROKER_URL = "https://puvip.co/ai6vAn";
const CHAMPIONSHIP_URL = "https://www.worldcupchampionships.com/world-cup-trading-championship-standings";
const TELEGRAM = "https://t.me/raeinexchangesupport";

const PARAS = [
  "Ciao, mi chiamo Paolo Bonfanti e dal 2017 investo in criptovalute. Dal 2018 invece, ho iniziato anche ad analizzare i mercati finanziari con focus su Forex, indici e materie prime. Con il tempo ed esperienza, ho migliorato il mio approccio basato su analisi tecnica ed individuazione di aree liquide tramite la Shadow Liquidity Pool (zone di ombra volumetrica).",
  "Credo che l'educazione finanziaria debba essere accessibile a chi, come me, vuole crescere in questo settore, accettando tutti i lati positivi che negativi. Il mio obiettivo è fornirti gli strumenti corretti per leggere il mercato in autonomia e in modo semplice — non di essere dipendente da un solo segnale, bensì di leggere ed interpretare l'intero contesto di mercato.",
  "RaeinExchange è la piattaforma che ho costruito per mettere tutto questo nelle tue mani: segnali di trading in tempo reale su XAUUSD, Bitcoin, criptovalute e coppie di valute, con entry, stop loss e take profit precisi e notifiche push istantanee. Trovi inoltre un calendario economico con i principali eventi macro come l'NFP, analisi potenziate dall'intelligenza artificiale (News AI e Raeinexchange AI), piani VIP e il Raeinex Network per crescere insieme.",
];

export default function About() {
  const { user } = useAuth();
  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      {user ? <Navbar /> : <PublicNav />}
      <main className="max-w-3xl mx-auto px-6 py-16 lg:py-24" data-testid="about-page">
        <span className="inline-flex items-center gap-2 text-xs font-mono px-3 py-1 rounded-full bg-blue-500/15 text-blue-400 border border-blue-500/20 mb-6">
          CHI SIAMO
        </span>
        <h1 className="text-4xl sm:text-5xl font-bold tracking-tight leading-[1.05] mb-10">
          Paolo Bonfanti: Trader e vincitore <span className="text-amber-400">WCTC Maggio 2026</span>.
        </h1>
        <div className="relative pl-6 border-l-2 border-blue-500/40 space-y-6">
          <Quote size={28} className="text-blue-500/40 absolute -left-4 -top-2" />
          {PARAS.map((p, i) => (
            <p key={p.slice(0, 24)} className="text-lg text-zinc-300 leading-relaxed animate-in-up" style={{ animationDelay: `${i * 0.1}s` }}>
              {p}
            </p>
          ))}
        </div>
        <div className="mt-12 flex flex-wrap gap-3">
          {["Dal 2017 in Crypto", "Dal 2018 sui mercati", "Shadow Liquidity Pool", "Analisi Tecnica"].map((t) => (
            <span key={t} className="px-3 py-2 rounded-md bg-[#141414] border border-white/10 text-sm text-zinc-300">{t}</span>
          ))}
        </div>

        <div className="mt-16 pt-12 border-t border-white/10">
          <span className="inline-flex items-center gap-2 text-xs font-mono px-3 py-1 rounded-full bg-emerald-500/15 text-emerald-400 border border-emerald-500/20 mb-6">
            TRADING
          </span>
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight leading-tight mb-6">
            Fai trading con i miei stessi <span className="text-emerald-400">privilegi</span>
          </h2>
          <p className="text-lg text-zinc-300 leading-relaxed">
            Se vuoi fare trading con i miei stessi privilegi, <span className="text-white font-medium">0 commissioni</span> e
            <span className="text-white font-medium"> spread contenuto</span>, registrati pure dal link.
          </p>
          <div className="mt-6 flex flex-wrap gap-4">
            <a href={BROKER_URL} target="_blank" rel="noopener noreferrer" data-testid="about-broker-btn"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-emerald-500 text-black font-semibold hover:bg-emerald-400 transition-colors">
              Registrati ora <ExternalLink size={16} />
            </a>
            <a href={TELEGRAM} target="_blank" rel="noopener noreferrer" data-testid="about-telegram-btn"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-white/20 text-white font-medium hover:bg-white/5 transition-colors">
              <Send size={16} /> Scrivimi su Telegram
            </a>
          </div>
          <p className="mt-12 text-lg text-zinc-300 leading-relaxed">
            Se mi seguirai passo passo, potrai anche tu diventare (come me) un campione di trading con un
            <span className="text-amber-400 font-semibold"> ROI mensile di oltre il 125%</span>.
          </p>
          <a href={CHAMPIONSHIP_URL} target="_blank" rel="noopener noreferrer" data-testid="about-roi-image"
            className="mt-6 block group rounded-lg overflow-hidden border border-white/10 hover:border-amber-500/50 transition-colors">
            <img src={ROI_IMG} alt="World Cup Trading Championship - Paolo Bonfanti 128.4%" className="w-full h-auto block" />
            <div className="flex items-center justify-center gap-2 py-3 bg-[#141414] text-sm text-amber-400 group-hover:text-amber-300 transition-colors">
              <Trophy size={16} /> Vedi la classifica ufficiale <ExternalLink size={14} />
            </div>
          </a>
        </div>
      </main>
    </div>
  );
}
